import React from 'react';
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
  type QueryKey,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { ApiError } from './client';

/** Shared query cache: REST snapshots are cached per key, live values come from the WebSocket. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: (n, e) => !(e instanceof ApiError && [400, 401, 403, 404, 422, 423].includes(e.status)) && n < 2,
    },
  },
});

export function QueryProvider({ children }: { children: React.ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}

/** A REST read: `useApi(['dashboard', period], () => call(api.GET('/dashboard', …)))`. */
export function useApi<T>(key: QueryKey, fn: () => Promise<T>, opts: Omit<UseQueryOptions<T, ApiError>, 'queryKey' | 'queryFn'> = {}) {
  return useQuery<T, ApiError>({ queryKey: key, queryFn: fn, ...opts });
}

export { useMutation, useQueryClient };
